import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFieldSet, TextareaField, SwitchField } from '@epoch-ui/components/Form';

import { LongAnswerFormValues } from '../schemas/LongAnswerSchema';

interface LongAnswerFormProps {
  disabled?: boolean;
}

export const LongAnswerForm: React.FC<LongAnswerFormProps> = ({ disabled = false }) => {
  const { register } = useFormContext<LongAnswerFormValues>();

  return (
    <div className="tw-flex tw-flex-grow tw-flex-col">
      <div className="tw-mb-6">
        <div className="tw-mb-[2px] tw-text-xl tw-font-medium tw-leading-7 tw-text-black">
          Long answer
        </div>
        <span className="tw-text-sm tw-font-normal tw-text-primary-grey">
          Collect detailed responses with a text area
        </span>
      </div>

      <FormFieldSet className="tw-gap-0">
        {/* Question prompt */}
        <TextareaField
          {...register('label')}
          label="Question"
          disabled={disabled}
          className="tw-mb-6 tw-mt-0"
        />

        {/* Required toggle */}
        <SwitchField {...register('isRequired')} label="Required" disabled={disabled} />
      </FormFieldSet>
    </div>
  );
};
